var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineGallerySlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.81 20.58C1.74 19.33 1.25 17.55 1.25 15V9c0-5.43 2.32-7.75 7.75-7.75h6c2.39 0 4.14.45 5.38 1.38a.75.75 0 0 1-.9 1.2c-.97-.73-2.43-1.08-4.48-1.08H9C4.39 2.75 2.75 4.39 2.75 9v6c0 2.15.39 3.66 1.2 4.62.27.32.23.79-.09 1.06-.14.11-.31.17-.48.17-.21 0-.43-.09-.57-.27zM8.999 22.75c-.79 0-1.5-.05-2.15-.14a.747.747 0 0 1-.63-.85c.06-.41.45-.69.85-.63.57.08 1.22.13 1.93.13h6c4.61 0 6.25-1.64 6.25-6.25V9c0-.33-.01-.66-.03-.96a.752.752 0 1 1 1.5-.1c.02.34.03.69.03 1.06v6c0 5.43-2.32 7.75-7.75 7.75h-6z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8c0-1.52 1.23-2.75 2.75-2.75S10.75 6.48 10.75 8 9.52 10.75 8 10.75 5.25 9.52 5.25 8zm1.5 0a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47 22.53a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22zM10.91 16.99a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0 .01.01.02.01.03 0l5.03-5.04c1.04-1.04 2.85-1.04 3.88 0l1.63 1.63c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0l-1.63-1.63c-.47-.47-1.29-.47-1.76 0l-5.03 5.04c-.3.29-.69.44-1.08.44-.39 0-.78-.15-1.07-.44z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineGallerySlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-gallery-slash.c977b2ddf6e18a7f95ca44bb7cc3e124.svg";
export { ForwardRef as ReactComponent };